export enum Strings {
  unknownError = "Unbekannter Fehler",
  wrongPin = "Falscher Pin.",
  calculations = "Preisberechnung",
  productsImport = "Produktimport",
  valuesImport = "Werteimport",
  brillantsImport = "Brillantenimport",
  artifactsGeneration = "Export",
}
